// removed by extract-text-webpack-plugin
module.exports = {"header":"app-pages-Library-Gratuity-ConfirmDeleteModal-__ConfirmDeleteModal___tw0lA","dialog":"app-pages-Library-Gratuity-ConfirmDeleteModal-__ConfirmDeleteModal___2DqY6"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Gratuity/ConfirmDeleteModal/ConfirmDeleteModal.css
// module id = 2410
// module chunks = 0